import { ReactNode } from 'react';

import { useActivePlatform } from 'src/hooks/use-active-platform';

import { PlatformEditionContext } from './platform-edition-context';

type Props = {
  children: ReactNode;
};

export function PlatformEditionProvider({ children }: Props) {
  const { features } = useActivePlatform();

  return (
    <PlatformEditionContext.Provider value={features.edition}>
      {children}
    </PlatformEditionContext.Provider>
  );
}
